import * as serviceWorker from "./serviceWorker";
import { bootstrap } from "./bootstrap/bootstrap.js";

bootstrap();

serviceWorker.unregister();
